import React, { useState, useEffect } from "react";
import UserPageLayout from "../../../../../../components/UserPageLayout";
import { useAppContext } from "../../../../../../../../context/AppContext";
import { Link } from "react-router-dom";
import ProductList from "../../components/ProductList";
import ProductDetails from "../../components/ProductDetails";
import { useParams } from "react-router-dom";

export default function Shop() {
    const { setPageTitle, setPageUserID } = useAppContext();
    const { slug } = useParams();

    const [loggedInUserData, setLoggedInUserData] = useState(null);



    useEffect(() => {
        const raw = localStorage.getItem("userData");
        const userData = raw ? JSON.parse(raw) : null;
        setLoggedInUserData(userData);

        setPageUserID(null);
        setPageTitle("Product List");
    }, [setPageTitle, setPageUserID]);

    return (
        <UserPageLayout>

            <div className="content-body">
                <div className="container-fluid">
                    <div className="row page-titles">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item  "><Link to={`/shop`}>Shop</Link></li>
                            {!slug && <li className="breadcrumb-item  active"><span>Product List</span></li>}
                            {slug && <li className="breadcrumb-item  active"><span>{slug}</span></li>}
                        </ol>
                    </div>

                    <div className="row">
                        {!slug ?
                            <ProductList /> :
                            <ProductDetails slug={slug} loggedInUserData={loggedInUserData} layout="compact" />
                        }
                    </div>

                </div>
            </div>


        </UserPageLayout>
    );
}